<ion-content class="ion-no-padding">
  <div class="lead-form itinerary-model-container">
    <div class="itinerary-model-header">
      <ion-header class="ion-no-border ion-padding-horizontal sticky-top bg-white">
        <ion-toolbar class="header-first-toolbar">
          <ion-title class="text-start ion-no-padding title-blue"><span *ngIf="!editPackageId">Create</span><span *ngIf="editPackageId">Edit</span> Package <span *ngIf="packageId">({{packageId}})</span></ion-title>
          
          <ion-buttons slot="end" class="ion-no-margin">
            <ion-button (click)="closeModal()" class="header-button-cancel unfilled-gray-btn">
              <ion-icon name="close-outline"></ion-icon>
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
  
      <div class="dashed-line"></div>
  
      <div class="d-flex py-1 flex-wrap ion-padding-horizontal nav-buttons-container">
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'details',  'tab-green': packageDetailsFormData?.dataSaved, 'tab-red': packageDetailsFormData?.dataInvalid }"  (click)="onViewChangeFromTab('details')">Package Details</ion-button>
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'route',  'tab-green': routeCraftFormData?.dataSaved, 'tab-red': routeCraftFormData?.dataInvalid }"  (click)="onViewChangeFromTab('route')" [disabled]="!packageId">Route Craft</ion-button>
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'pricing',  'tab-green': pricingFormData?.dataSaved, 'tab-red': pricingFormData?.dataInvalid }"  (click)="onViewChangeFromTab('pricing')" [disabled]="!packageId">Pricing</ion-button>
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'inclusions',  'tab-green': inclusionsAndExclusionsFormData?.dataSaved, 'tab-red': inclusionsAndExclusionsFormData?.dataInvalid }"  (click)="onViewChangeFromTab('inclusions')" [disabled]="!packageId">I&E</ion-button>
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'combined-terms',  'tab-green': termsAndConditionsFormData?.dataSaved, 'tab-red': termsAndConditionsFormData?.dataInvalid }"  (click)="onViewChangeFromTab('combined-terms')" [disabled]="!packageId">T&C</ion-button>
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'important',  'tab-green': importantInformationFormData?.dataSaved, 'tab-red': importantInformationFormData?.dataInvalid }"  (click)="onViewChangeFromTab('important')" [disabled]="!packageId">Important Information</ion-button>
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'notes',  'tab-green': notesFormData?.dataSaved, 'tab-red': notesFormData?.dataInvalid }"  (click)="onViewChangeFromTab('notes')" [disabled]="!packageId">Notes</ion-button>
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'templates-details', 'tab-green': templatesDetailsFormData?.dataSaved}"  (click)="onViewChangeFromTab('templates-details')" [disabled]="!packageId">Customize Template</ion-button>
        <ion-button class="unfilled-black-btn-sm" (click)="openReviewScreen()" [disabled]="!packageId">Review</ion-button>
      </div>
    </div>
    

    <div [ngSwitch]="componentView" class="itinerary-model-content-main">

      <!-- package details component ( storing destination and others) -->
      <app-dmc-package-details  *ngSwitchCase="'details'" [packageId]="packageId"
      [editPackageId]="editPackageId"
      (viewChange)="onViewChange($event)"
      (storeFormData)="storePackageDetailsData($event)"
      [storedFormData]="packageDetailsFormData"
      (assignPackageId)="assignPackageId($event)"
      (destinationDataChanged)="onDestinationsDataChanged()"
      ></app-dmc-package-details>

      <!-- Route craft -->
      <app-dmc-package-route-craft  *ngSwitchCase="'route'" [packageId]="packageId"
      [editPackageId]="editPackageId"
      (viewChange)="onViewChange($event)"
      (storeFormData)="storeRouteCraftData($event)"
      [storedFormData]="routeCraftFormData"
      [packageDetailsFormData]="packageDetailsFormData"
      ></app-dmc-package-route-craft>

      <!-- Pricing -->
      <app-dmc-package-pricing  *ngSwitchCase="'pricing'" [packageId]="packageId"
      [editPackageId]="editPackageId"
      (viewChange)="onViewChange($event)"
      (storeFormData)="storePricingData($event)"
      (storeTransfersFormData)="storeTransfersData($event)"
      (storeOptinalSightseeingFormData)="storeOptinalSightseeingData($event)"
      [storedFormData]="pricingFormData"
      [transfersFormData]="transfersFormData"
      [optinalSightseeingFormData]="optinalSightseeingFormData"
      [packageDetailsFormData]="packageDetailsFormData"
      ></app-dmc-package-pricing>

      <!-- Inclusoin exclusions -->
      <app-dmc-package-inclusions-and-exclusions  *ngSwitchCase="'inclusions'" [packageId]="packageId"
      [editPackageId]="editPackageId"
      (viewChange)="onViewChange($event)"
      (storeFormData)="storeInclusionsAndExclusionsData($event)"
      [storedFormData]="inclusionsAndExclusionsFormData"
      ></app-dmc-package-inclusions-and-exclusions>

      <!-- Combined terms -->
      <app-dmc-combined-terms *ngSwitchCase="'combined-terms'" [packageId]="packageId" (viewChange)="onViewChange($event)" 
      [cancellationPolicyFormData]="cancellationPolicyFormData"
      [termsAndConditionsFormData]="termsAndConditionsFormData"
      (storeTermsFormData)="storeTermsAndConditionsData($event)"
      (storeCancellationPolicyFormData)="storeCancellationPolicyData($event)"
      [editPackageId]="editPackageId"></app-dmc-combined-terms>

      <!-- Terms and conditons -->
      <app-dmc-package-terms-and-conditions  *ngSwitchCase="'terms'" [packageId]="packageId"
      [editPackageId]="editPackageId"
      (viewChange)="onViewChange($event)"
      (storeFormData)="storeTermsAndConditionsData($event)"
      [storedFormData]="termsAndConditionsFormData"
      ></app-dmc-package-terms-and-conditions>

      <!-- Cancellation policy -->
      <app-dmc-package-cancellation-policy  *ngSwitchCase="'cancellation'" [packageId]="packageId"
      [editPackageId]="editPackageId"
      (viewChange)="onViewChange($event)"
      (storeFormData)="storeCancellationPolicyData($event)"
      [storedFormData]="cancellationPolicyFormData"
      ></app-dmc-package-cancellation-policy>

      <!-- Important information -->
      <app-dmc-package-important-information  *ngSwitchCase="'important'" [packageId]="packageId"
      [editPackageId]="editPackageId"
      (viewChange)="onViewChange($event)"
      (storeFormData)="storeImportantInformationData($event)"
      [storedFormData]="importantInformationFormData"
      ></app-dmc-package-important-information>

      <!-- Notes -->
      <app-dmc-package-notes  *ngSwitchCase="'notes'" [packageId]="packageId"
      [editPackageId]="editPackageId"
      (viewChange)="onViewChange($event)"
      (storeFormData)="storeNotesData($event)"
      [storedFormData]="notesFormData"
      ></app-dmc-package-notes>

      <!-- Customize template -->
       <app-dmc-package-template-data *ngSwitchCase="'templates-details'" [packageId]="packageId"
      (viewChange)="onViewChange($event)" 
      (openReviewScreen)="openQuoteReview()" 
      (storeFormData)="storeTemplateDetailsData($event)" 
      [storedFormData]="templatesDetailsFormData"
      ></app-dmc-package-template-data>

    </div>
  </div>
</ion-content>
